import Page from '../../classes/Page'
import each from 'lodash/each'

import { app } from '../../utils/store'

export default class SingleInspiration extends Page{
    constructor(){
        super({
            id : 'single_inspiration',
            element: '[data-app-page]',
            elements: { 
                btn_view_all : '#view-all-related',
                element_datas_related : '.element',
            },
            scroller: app.content
        })
    }

    create() {
        super.create()
        if (this.elements.btn_view_all) {
            this.viewAll();
        }
    }

    viewAll = () => {
        this.elements.btn_view_all.onclick = (event) => {
            event.preventDefault();
            each(this.elements.element_datas_related, (item) => {
                item.style.setProperty('display', 'block');
            });
            event.target.style.setProperty('display', 'none');
        };
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}